<template>
  <div class="alert-content" v-if="alert" v-show="showAlert">
    <div class="alert" >
      {{ alert }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Func4DetalheAlerta',
  data: () => {
    return {
      showAlert: true
    }
  },
  props: {
    alert: {}
  }
}
</script>

<style scoped lang="less">

.alert-content {
  background-color: var(--cor-primaria-aplicacao-transparent);
  border-radius: 6px;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  place-items: center;

  .alert {
    color: var(--cor-primaria-aplicacao);
  }

  .icon {
    color: white;
    background-color: var(--cor-primaria-aplicacao);
    border-radius: 100%;
    width: 20px;
    font-size: 12px;
    text-align: center;
    display: flex;
    place-content: center;
    place-items: center;
    cursor: pointer;
  }
}

</style>
